module.exports = __webpack_public_path__ + "img/spotify.41dad92c.svg";